import {ImportResultApiDto} from "../../api/model/rest";

export class ImportResult {
	constructor(public readonly error: string[]) {}

	static fromJson(json: ImportResultApiDto) {
		const errors = json.errors ? json.errors.map(e => e.error) : [];
		return new ImportResult(errors);
	}
}